export default "__VITE_ASSET__C8YzzaV5__"